import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import theLocalStorageUtils from './LocalStorageUtils';
import utils from './QSUtils';

export default {
    decode(jwt: string): any {
        const base64Url = jwt.split('.')[1];
        return JSON.parse(window.atob(base64Url));
    },
    getValue(jwt: string, value: string): string {
        let result = '';
        const json = this.decode(jwt);

        if (utils.isKeyInObject(json, value)) {
            result = json[value];
        }
        return result;
    },
    getPassportId(jwt: string) {
        return this.getValue(jwt, 'passportId');
    },
    getIpAddress(jwt: string) {
        return this.getValue(jwt, 'ip');
    },
    getCustomerNumber(jwt: string) {
        return this.getValue(jwt, 'cn');
    },
    getJWTPassportId(): number {
        const jwt = theLocalStorageUtils.get(LocalStorageKeys.qsAccessToken);
        if (jwt) {
            return Number(this.getPassportId(jwt)) || 0
        }

        return 0;
    }
};
